import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './lib/query';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/Toast';
import App from './App';
import { installChunkReloadHandler } from './lib/chunkReload';
import './index.css';

// Self-heal a stale-bundle chunk failure (dashboard redeployed under an open
// tab) by reloading once, instead of crashing to the error screen.
installChunkReloadHandler();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
);
